<template>
  <div>
    <span v-if="noTransport"></span>
    <v-icon v-else-if="!inTransport" x-small class="pl-1 pr-0">{{ TRANSPORT_ICONS[0] }}</v-icon>
    <v-icon v-else x-small class="pl-1 pr-0">{{ TRANSPORT_ICONS[inTransport] }}</v-icon>
    <span class="text-no-wrap">{{ showDate(inDate) }}</span>
    <br v-if="!horizontal" />
    <span v-if="noTransport" class="px-1">-</span>
    <v-icon v-else-if="!outTransport" x-small class="pl-2 pr-0">{{ TRANSPORT_ICONS[0] }}</v-icon>
    <v-icon v-else x-small class="pl-2 pr-0">
      {{
      TRANSPORT_ICONS[outTransport]
      }}
    </v-icon>
    <span class="text-no-wrap">{{ showDate(outDate) }}</span>
    <br v-if="!horizontal" />
    <v-icon x-small :color="color" class="pl-3 pr-1">mdi-bed</v-icon>
    <span>{{ visitDuration }}</span>
  </div>
</template>

<script>
import moment from 'moment'

const transportIcons = [
  'mdi-help-circle',
  'mdi-airplane',
  'mdi-car',
  'mdi-ferry',
  'mdi-account',
  'mdi-train'
]

export default {
  props: {
    inDate: {
      type: String,
      required: true
    },
    outDate: {
      type: String,
      required: true
    },
    visitDuration: {
      type: Number,
      required: false
    },
    inTransport: {
      type: Number,
      required: false
    },
    outTransport: {
      type: Number,
      required: false
    },
    horizontal: {
      type: Boolean,
      required: false
    },

    noTransport: {
      type: Boolean,
      required: false
    },
    showInShort: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'black'
    }
  },

  created() {
    this.TRANSPORT_ICONS = transportIcons
  },

  methods: {
    showDate(date) {
      const d = new Date(date)
      moment.locale('ru')
      if (this.showInShort) {
        return moment(d).format('D.MM')
      } else {
        return moment(d).format('D MMMM')
      }
    }
  }
}
</script>

<style></style>
